import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../store/store";

import CashWithdrawalService from "../../services/cash/cashWithdrawalService";

import {

    setCashWithdrawalForm,
    updateCashWithdrawalField,
    clearCashWithdrawalForm,

    setLoading,

    openModal,
    closeModal

} from "../../store/slices/cash/cashWithdrawalSlice";

import useAlerts from "../useAlerts";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";

import { useCashSession } from "./useCashSession";
import { useCashMovements } from "./useCashMovements";
import { CashMovementType } from "../../types/cash/CashMovementType";

export const useCashWithdrawal = () => {

    const dispatch: AppDispatch = useDispatch();

    const {

        form,
        loading,
        showModal

    } = useSelector((state: RootState) => state.cashWithdrawal);

    const { show: showAlert } = useAlerts();

    const { handle } = useApiErrorHandler();

    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

    /**
     * 💸 Registrar retiro
     */
    const { getActiveSession } = useCashSession();
    const { getSessionMovements } = useCashMovements();

    const withdraw = async (data: any) => {

        try {

            showLoadingIndicator();
            dispatch(setLoading(true));

            const response = await CashWithdrawalService.withdraw(data);

            if (response?.statusCode === 200 || response?.statusCode === 201) {

                showAlert(
                    response.type,
                    response.title,
                    response.message
                );

                dispatch(closeModal());
                dispatch(clearCashWithdrawalForm());

                /**
                 * 🔄 REFRESCAR ESTADO DE CAJA
                 */
                await getActiveSession();

                /**
                 * 🔄 RECARGAR HISTORIAL DE RETIROS
                 */
                await getSessionMovements(
                    data.sessionId,
                    [CashMovementType.WITHDRAWAL]
                );

            }

        } catch (error) {

            handle(error);

        } finally {

            hideLoadingIndicator();
            dispatch(setLoading(false));

        }

    };

    /**
     * ✏️ Actualizar campo
     */
    const updateField = (field: string, value: any) => {

        dispatch(updateCashWithdrawalField({
            field,
            value
        }));

    };

    /**
     * 🧠 Set form
     */
    const setForm = (data: any) => {

        dispatch(setCashWithdrawalForm(data));

    };

    /**
     * 🧹 Clear form
     */
    const clearForm = () => {

        dispatch(clearCashWithdrawalForm());

    };

    /**
     * 📂 Modales
     */
    const open = () => dispatch(openModal());

    const close = () => dispatch(closeModal());

    const clear = () => {
        dispatch(clearCashWithdrawalForm());
        dispatch(closeModal());
    };

    return {

        form,
        loading,
        showModal,

        withdraw,

        updateField,
        setForm,
        clearForm,
        clear,

        open,
        close

    };

};